import type { NitroFetchRequest } from 'nitropack/types'
import type { UseFetchOptions } from 'nuxt/app'

/**
 * Расширенная обёртка над useFetch, сохраняющая типизацию Nitro API
 */
export function useNuxtApi<
  T = unknown,
  R extends NitroFetchRequest = NitroFetchRequest,
>(request: R, options?: UseFetchOptions<T>) {
  return useFetch<T, R>(request, {
    ...(options as any),
    headers: {
      'x-request-host': useRequestURL().host,
    },
  })
}
